module.exports = __webpack_public_path__ + "img/vert-3.88c01613.png";